import { AuthBaseClient } from '../base-client';
import type { VoicePreviewBody } from './types';

/**
 * Client for `/api/voice/preview` (ADR-344): a line spoken in the voice agent's
 * voice, returned as audio. Session-cookie auth (browser).
 */
export class VoicePreviewClient extends AuthBaseClient {
  /** Synthesize `body.text`; resolves to an audio Blob (`audio/mpeg`). */
  async speak(body: VoicePreviewBody, signal?: AbortSignal): Promise<Blob> {
    return this.postBlob('/api/voice/preview', body, signal);
  }
}
